<section class="parker-banner">
    <app-mini-env-banner [slides]="bannerSlides" (butonAction)="onSliderBtnAction()"></app-mini-env-banner>
</section>  


<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block
        [miniTitle]="'Why Choose Us?'"
        [title]="'WoW Health makes Healthcare Flexible'"
        [description]="'Imagine healthcare not being a burden, but an accessible, clear, and trustworthy pathway. Thats how it is with WoW.'"
        [style]="'max-width: 703px;'"
        ></app-mini-env-heading-block>

      <div class="row" style="row-gap: 15px;margin-top: 30px;gap: 15px;">
        <div *ngFor="let item of benefits" class="card-box col-12">
          <app-mini-env-tall-info-card 
                                  [title]="item.title"
                                  [description]="item.description"
                                  [bgImage]="item.bgImage"
                                 >
          </app-mini-env-tall-info-card>
        </div>
      </div>
  </div>
</section>

<section class="container-fluid services-section">
    <div class="container">
        
        <app-mini-env-heading-block
            [miniTitle]="'Services'"
            [title]="'Perfect Blend of Virtual & In-person Services'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>

        <app-mini-env-tabs [serviceNames]="services" [imgSrc]="imgSrc" (buttonAction)="buttonAction()"></app-mini-env-tabs>    

    </div>
</section>

<section class="container-fluid empower-health-section">
    <div class="d-flex align-items-center wrapper container">
      <div class="col-md-6 col-12">
          <div class="d-flex">
              <div>
                  <app-mini-env-heading-block
                      [miniTitle]="'Personal Membership'"
                      [title]="'Healthcare on Your Terms, Anytime'"
                      [description]="'WoW Health is your personal health membership. Keep your plan, access resources on our mobile app, and stay healthy on your terms regardless of your employment status. Join WoW Health today and focus on your health, not just health insurance.'"
                      [style]="'max-width: 684px;'" [leftAlign]="true"
                      ></app-mini-env-heading-block>

                      <button (click)="buttonAction()" class="btn btn-primary learn-more mt-20">
                        Get Started
                      </button>
              </div>
          </div>
      </div>
      <div class="col-md-6 col-12">
          <div class="d-flex img-box">
            <img class="granny-img" [src]="'assets/tenant-assets/mini-env/images/patient-and-nurse.png'" style="object-fit: cover;border-radius: 8px;" alt="">
          </div>
      </div>
  </div>
</section>

<!-- <section>
  <div class="container-fluid video-section">

     <app-mini-env-heading-block
    [miniTitle]="'See WoW Health in Action'"
    [title]="'Let’s Dive Deep Into Understanding Wow Health'"
    [description]="'Heres a detailed video about how we make helathcare trustworthy for our WoW members'"
    [style]="'max-width: 740px;'"
    ></app-mini-env-heading-block>

    <div class="container">
      <app-video-player></app-video-player>
    </div>
  </div>
</section> -->

<section id="membership-section" class="container-fluid membershipplans-section membership-section">
  <div class="container">
    <div class="row basic-section-gap" style="flex-direction: row;">
      <div class="col-md-12">
        <app-mini-env-heading-block
            [miniTitle]="'Affordable Healthcare solution for you!'"
            [title]="'Healthcare access with membership,no insurance needed'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>
      </div>
      <div class="col-md-12">
        <app-membership-plan
            [label]="('MEMBERSHIP.LABEL' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note1]="('MEMBERSHIP.NOTE1' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note2]="('MEMBERSHIP.NOTE2' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note3]="('MEMBERSHIP.NOTE3' | translateIt: {language: sharedService.currentLanguage} | async)"
            [membershipPlanCode]="membershipPlanCode"
            [btnLabel]="'Select Membership'"></app-membership-plan>
      </div>

    </div>
  </div>
</section>

<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block
    [miniTitle]="'How it works'"
    [title]="'Getting Started to Avail Your WoW Benefits Is Super Easy!'"
    [description]="'Follow these simple steps to start your WoW Health journey today.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [imgLink]="sharedService.imagesUrl + 'woman-wave-phone.webp'"></app-imagebox-bullet-scroll>
</section>

<section class="container-fluid bg-content">
  <div class="container">
    <app-mini-env-bg-content [title]="'It’s Never Too Late to Start Better With Your Health!'" 
                             [mobileTitle]="'Start your Health Transformation with Wow Health Today'"
                             [description]="'Dont wait another moment to prioritize your health. Join WoW Health now and step into a world of personalized, accessible, and affordable healthcare thats always at your fingertips.'"
                             [bgClass]="bgClass" (buttonAction)="buttonAction()"></app-mini-env-bg-content>
  </div>
</section>

<section class="container-fluid testimonial-section">

  <app-mini-env-heading-block
    [miniTitle]="'Testimonials'"
    [title]="'What WoW Health Users are Saying'"
    [description]="'Hear from members enjoying affordable, transparent care every day. Transparent pricing is changing their healthcare experience.'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

  <app-mini-env-testimonials></app-mini-env-testimonials>
</section>


<section class="container-fluid faq-section">
  <div class="container">
    
    <app-mini-env-heading-block
    [miniTitle]="'FAQs'"
    [title]="'Frequently Asked Questions'"
    [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

    <div class="mt-30">
       <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>  

<section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section>
<!--  How can we help Section End-->